const processArray = async ({ array, itemFunc, afterArrFunc = () => {} }) => {
  for (const [index, value] of array.entries()) {
    await itemFunc(value, index);
  }
  afterArrFunc();
};
export default processArray;
